package fr.arcplex.network.model

/**
 * Unified screen: the menu rail plus the hero rail and the ordered result rails.
 * Replaces the legacy `Line` (menu/fixed_element) + `lines` page model.
 */
data class Screen(
    val id: String?,
    val kind: ScreenKind,
    val label: String,
    val backgroundImage: String?,
    val backgroundHex: String?,
    val menu: Rail,
    val hero: Rail,
    val rails: List<Rail>
)

enum class ScreenKind {
    NORMAL, FILM, SEARCH
}
